export const translations = {
  de: {
    languageName: "Deutsch",
    flag: "🇩🇪",
    appTitle: "MFA Status Check",
    appSubtitle: "Zwei-Faktor-Authentifizierung",
    loginPrompt: "Melde dich mit deinem Microsoft-Konto an, um deinen MFA-Status zu prüfen.",
    signInButton: "Mit Microsoft anmelden",
    signOutButton: "Abmelden",
    accountDetails: "Konto",
    detectedLocation: "Standort",
    refreshStatus: "Erneut prüfen",
    checkingStatus: "Status wird geprüft...",
    helloUser: "Hallo",
    
    // Status - Optimal (Green)
    statusOptimalBadge: "Alles in Ordnung",
    statusOptimalTitle: "Du bist optimal geschützt!",
    statusOptimalSubtitle: "Keine Aktion erforderlich.",
    statusOptimalDesc: "Für dein Konto ist die Microsoft Authenticator App aktiv eingerichtet. Du musst nichts weiter tun – vielen Dank!",
    statusOptimalFidoDesc: "Für dein Konto ist ein sicherer Passkey (Sicherheitsschlüssel) aktiv eingerichtet. Du musst nichts weiter tun – vielen Dank!",
    statusOptimalAction: "Alles erledigt",

    // Status - Legacy / SMS (Neutral)
    statusNeutralBadge: "Handlung empfohlen",
    statusNeutralTitle: "Du nutzt noch SMS oder Anruf",
    statusNeutralSubtitle: "Bitte wechsle zur Microsoft Authenticator App.",
    statusNeutralDesc: "SMS und Telefonanrufe gelten als veraltet und unzuverlässig. Bitte steige jetzt auf die Microsoft Authenticator App um.",
    statusNeutralAction: "Jetzt Authenticator einrichten",

    // Status - No MFA (Red)
    statusWarningBadge: "Aktion erforderlich",
    statusWarningTitle: "Du hast noch kein MFA eingerichtet!",
    statusWarningSubtitle: "Bitte richte jetzt deinen zweiten Faktor ein.",
    statusWarningDesc: "Ohne zweiten Faktor ist dein Zugriff gefährdet. Richte bitte jetzt die Microsoft Authenticator App ein.",
    statusWarningAction: "Jetzt Authenticator einrichten",

    // Company Device Pre-installed Notice
    appPreinstalledNotice: "Hinweis: Die Microsoft Authenticator App ist auf deinem Dienstgerät bereits vorinstalliert.",

    // PDF Guide
    pdfGuideTitle: "Schritt-für-Schritt Anleitung (PDF)",
    pdfGuideDesc: "Bebilderte PDF-Anleitung zur Einrichtung der Microsoft Authenticator App.",
    pdfGuideButton: "PDF-Anleitung öffnen",

    // Accordion
    toggleDetailsShow: "Details zu meinen hinterlegten Methoden anzeigen",
    toggleDetailsHide: "Details ausblenden",

    // Methods List
    methodsHeader: "Hinterlegte Anmeldemethoden",
    methodsDescription: "Diese Faktoren sind aktuell für dein Konto hinterlegt:",
    methodAuthenticator: "Microsoft Authenticator App",
    methodPhone: "Telefonanruf / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Andere Authenticator-App (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Passwort",
    methodOther: "Sonstige Methode",
    badgeRecommended: "Empfohlen",
    badgeActive: "Aktiv",
    badgeLegacy: "Veraltet (SMS)",
    badgePrimary: "1. Faktor",
    noMethodsFound: "Keine Methoden gefunden.",

    // Support (Ticket Self-Service Portal)
    supportTitle: "Brauchst du Hilfe?",
    supportDesc: "Erstelle ein Ticket im IT Self-Service Portal (SSP), falls du Unterstützung benötigst.",
    supportButton: "Ticket im IT Self-Service Portal erstellen",
    demoModeNotice: "Demo-Vorschau aktiv"
  },

  en: {
    languageName: "English",
    flag: "🇬🇧",
    appTitle: "MFA Status Check",
    appSubtitle: "Multi-Factor Authentication",
    loginPrompt: "Sign in with your Microsoft account to check your MFA status.",
    signInButton: "Sign in with Microsoft",
    signOutButton: "Sign out",
    accountDetails: "Account",
    detectedLocation: "Location",
    refreshStatus: "Check again",
    checkingStatus: "Checking status...",
    helloUser: "Hello",

    statusOptimalBadge: "All Good",
    statusOptimalTitle: "You're all set and fully protected!",
    statusOptimalSubtitle: "No action required.",
    statusOptimalDesc: "The Microsoft Authenticator app is active on your account. You don't need to do anything – thank you!",
    statusOptimalFidoDesc: "A secure passkey (security key) is active on your account. You don't need to do anything – thank you!",
    statusOptimalAction: "All done",

    statusNeutralBadge: "Action Recommended",
    statusNeutralTitle: "You are still using SMS or Phone Call",
    statusNeutralSubtitle: "Please switch to the Microsoft Authenticator app.",
    statusNeutralDesc: "SMS and phone calls are legacy and less reliable. Please switch to the Microsoft Authenticator app for better security and ease of use.",
    statusNeutralAction: "Set up Authenticator now",

    statusWarningBadge: "Action Required",
    statusWarningTitle: "You haven't set up MFA yet!",
    statusWarningSubtitle: "Please set up your second factor now.",
    statusWarningDesc: "Your account is not protected with two-factor authentication. Please set up the Microsoft Authenticator app now to keep your access secure.",
    statusWarningAction: "Set up Authenticator now",

    appPreinstalledNotice: "Note: The Microsoft Authenticator app is already pre-installed on your company device.",

    pdfGuideTitle: "Step-by-Step Guide (PDF)",
    pdfGuideDesc: "Illustrated PDF guide for setting up the Microsoft Authenticator app.",
    pdfGuideButton: "Open PDF Guide",

    toggleDetailsShow: "Show details of registered methods",
    toggleDetailsHide: "Hide details",

    methodsHeader: "Your Registered Methods",
    methodsDescription: "The following authentication factors are registered for your account:",
    methodAuthenticator: "Microsoft Authenticator App",
    methodPhone: "Phone Call / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Other Authenticator App (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Password",
    methodOther: "Other Method",
    badgeRecommended: "Recommended",
    badgeActive: "Active",
    badgeLegacy: "Legacy (SMS)",
    badgePrimary: "1st Factor",
    noMethodsFound: "No methods found.",

    supportTitle: "Need help?",
    supportDesc: "Create a ticket in the IT Self-Service Portal (SSP) if you need assistance.",
    supportButton: "Create ticket in IT Self-Service Portal",
    demoModeNotice: "Demo Preview active"
  },

  da: {
    languageName: "Dansk",
    flag: "🇩🇰",
    appTitle: "MFA Status Check",
    appSubtitle: "Totrinsbekræftelse",
    loginPrompt: "Log på med din Microsoft-konto for at tjekke din MFA-status.",
    signInButton: "Log på med Microsoft",
    signOutButton: "Log ud",
    accountDetails: "Konto",
    detectedLocation: "Placering",
    refreshStatus: "Tjek igen",
    checkingStatus: "Tjekker status...",
    helloUser: "Hej",

    statusOptimalBadge: "Alt er i orden",
    statusOptimalTitle: "Du er optimalt beskyttet!",
    statusOptimalSubtitle: "Ingen handling påkrævet.",
    statusOptimalDesc: "Microsoft Authenticator-appen er aktiv på din konto. Du behøver ikke foretage dig noget – tak!",
    statusOptimalFidoDesc: "En sikker passkey (sikkerhedsnøgle) er aktiv på din konto. Du behøver ikke foretage dig noget – tak!",
    statusOptimalAction: "Alt er klar",

    statusNeutralBadge: "Handling anbefales",
    statusNeutralTitle: "Du bruger stadig SMS eller telefonopkald",
    statusNeutralSubtitle: "Skift venligst til Microsoft Authenticator-appen.",
    statusNeutralDesc: "SMS og opkald er ældre metoder med lavere sikkerhed. Skift til Microsoft Authenticator-appen for bedre sikkerhed og bekvemmelighed.",
    statusNeutralAction: "Konfigurer Authenticator nu",

    statusWarningBadge: "Handling påkrævet",
    statusWarningTitle: "Du har endnu ikke opsat MFA!",
    statusWarningSubtitle: "Opsæt venligst totrinsbekræftelse nu.",
    statusWarningDesc: "Din konto er ikke beskyttet med totrinsbekræftelse. Opsæt venligst Microsoft Authenticator-appen nu.",
    statusWarningAction: "Konfigurer Authenticator nu",

    appPreinstalledNotice: "Bemærk: Microsoft Authenticator-appen er allerede forudinstalleret på din arbejdsenhed.",

    pdfGuideTitle: "Trin-for-trin vejledning (PDF)",
    pdfGuideDesc: "Illustreret PDF-vejledning til opsætning af Microsoft Authenticator.",
    pdfGuideButton: "Åbn PDF-vejledning",

    toggleDetailsShow: "Vis detaljer om mine metoder",
    toggleDetailsHide: "Skjul detaljer",

    methodsHeader: "Dine registrerede metoder",
    methodsDescription: "Følgende faktorer er registreret for din konto:",
    methodAuthenticator: "Microsoft Authenticator App",
    methodPhone: "Telefonopkald / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Anden Authenticator (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Adgangskode",
    methodOther: "Anden metode",
    badgeRecommended: "Anbefalet",
    badgeActive: "Aktiv",
    badgeLegacy: "Forældet (SMS)",
    badgePrimary: "1. faktor",
    noMethodsFound: "Ingen metoder fundet.",

    supportTitle: "Brug for hjælp?",
    supportDesc: "Opret en sag i IT Self-Service Portalen (SSP), hvis du har brug for hjælp.",
    supportButton: "Opret sag i IT Self-Service Portal",
    demoModeNotice: "Demo-visning aktiv"
  },

  hu: {
    languageName: "Magyar",
    flag: "🇭🇺",
    appTitle: "MFA Status Check",
    appSubtitle: "Kétlépcsős azonosítás",
    loginPrompt: "Jelentkezz be Microsoft-fiókoddal az MFA-állapot ellenőrzéséhez.",
    signInButton: "Bejelentkezés Microsofttal",
    signOutButton: "Kijelentkezés",
    accountDetails: "Fiók",
    detectedLocation: "Helyszín",
    refreshStatus: "Újraellenőrzés",
    checkingStatus: "Állapot ellenőrzése...",
    helloUser: "Szia",

    statusOptimalBadge: "Minden rendben",
    statusOptimalTitle: "Fiókod optimálisan védett!",
    statusOptimalSubtitle: "Nincs szükség további teendőre.",
    statusOptimalDesc: "A Microsoft Authenticator alkalmazás aktívan be van állítva a fiókodhoz. További teendőd nincs – köszönjük!",
    statusOptimalFidoDesc: "Fiókodhoz biztonságos passkey (biztonsági kulcs) van beállítva. További teendőd nincs – köszönjük!",
    statusOptimalAction: "Minden kész",

    statusNeutralBadge: "Javasolt lépés",
    statusNeutralTitle: "Még SMS-t vagy telefonhívást használsz",
    statusNeutralSubtitle: "Kérjük, válts a Microsoft Authenticator alkalmazásra.",
    statusNeutralDesc: "Az SMS és telefonhívás elavult módszernek számít. A nagyobb biztonság és kényelem érdekében válts az ingyenes Microsoft Authenticator appra.",
    statusNeutralAction: "Authenticator beállítása most",

    statusWarningBadge: "Beavatkozás szükséges",
    statusWarningTitle: "Még nincs beállítva az MFA!",
    statusWarningSubtitle: "Kérjük, állítsd be most a kétlépcsős azonosítást.",
    statusWarningDesc: "Fiókodhoz még nincs második biztonsági lépés beállítva. A zavartalan hozzáféréshez állítsd be most a Microsoft Authenticator appot.",
    statusWarningAction: "Authenticator beállítása most",

    appPreinstalledNotice: "Megjegyzés: A Microsoft Authenticator alkalmazás már előre telepítve van a céges eszközödön.",

    pdfGuideTitle: "Lépésről lépésre útmutató (PDF)",
    pdfGuideDesc: "Képes PDF útmutató a Microsoft Authenticator alkalmazás beállításához.",
    pdfGuideButton: "PDF útmutató megnyitása",

    toggleDetailsShow: "Regisztrált módszerek részletei",
    toggleDetailsHide: "Részletek elrejtése",

    methodsHeader: "Regisztrált hitelesítési módszerek",
    methodsDescription: "A fiókodhoz jelenleg az alábbi módszerek vannak megadva:",
    methodAuthenticator: "Microsoft Authenticator app",
    methodPhone: "Telefonhívás / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Egyéb hitelesítő (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Jelszó",
    methodOther: "Egyéb módszer",
    badgeRecommended: "Ajánlott",
    badgeActive: "Aktív",
    badgeLegacy: "Elavult (SMS)",
    badgePrimary: "1. tényező",
    noMethodsFound: "Nincsenek módszerek.",

    supportTitle: "Segítségre van szükséged?",
    supportDesc: "Nyiss egy hibajegyet az IT Self-Service Portálon (SSP), ha támogatásra van szükséged.",
    supportButton: "Hibajegy nyitása az IT Self-Service Portálon",
    demoModeNotice: "Demó előnézet aktív"
  },

  sv: {
    languageName: "Svenska",
    flag: "🇸🇪",
    appTitle: "MFA Status Check",
    appSubtitle: "Tvåfaktorsautentisering",
    loginPrompt: "Logga in med ditt Microsoft-konto för att kontrollera din MFA-status.",
    signInButton: "Logga in med Microsoft",
    signOutButton: "Logga ut",
    accountDetails: "Konto",
    detectedLocation: "Plats",
    refreshStatus: "Kontrollera igen",
    checkingStatus: "Kontrollerar status...",
    helloUser: "Hej",

    statusOptimalBadge: "Allt är klart",
    statusOptimalTitle: "Du är optimalt skyddad!",
    statusOptimalSubtitle: "Ingen åtgärd krävs.",
    statusOptimalDesc: "Microsoft Authenticator-appen är aktiv för ditt konto. Du behöver inte göra någonting – tack!",
    statusOptimalFidoDesc: "En säker passkey (säkerhetsnyckel) är aktiv för ditt konto. Du behöver inte göra någonting – tack!",
    statusOptimalAction: "Allt klart",

    statusNeutralBadge: "Åtgärd rekommenderas",
    statusNeutralTitle: "Du använder fortfarande SMS eller samtal",
    statusNeutralSubtitle: "Vänligen byt till Microsoft Authenticator-appen.",
    statusNeutralDesc: "SMS och samtal är äldre och mindre pålitliga metoder. Byt till Microsoft Authenticator-appen för bättre säkerhet och smidighet.",
    statusNeutralAction: "Konfigurera Authenticator nu",

    statusWarningBadge: "Åtgärd krävs",
    statusWarningTitle: "Du har inte ställt in MFA ännu!",
    statusWarningSubtitle: "Konfigurera din andra faktor nu.",
    statusWarningDesc: "Ditt konto saknar tvåfaktorsautentisering. Installera Microsoft Authenticator-appen nu för att säkra din åtkomst.",
    statusWarningAction: "Konfigurera Authenticator nu",

    appPreinstalledNotice: "Obs: Microsoft Authenticator-appen är redan förinstallerad på din företagsenhet.",

    pdfGuideTitle: "Steg-för-steg guide (PDF)",
    pdfGuideDesc: "Illustrerad PDF-guide för konfigurering av Microsoft Authenticator.",
    pdfGuideButton: "Öppna PDF-guide",

    toggleDetailsShow: "Visa detaljer om mina metoder",
    toggleDetailsHide: "Dölj detaljer",

    methodsHeader: "Dina registrerade metoder",
    methodsDescription: "Följande faktorer är registrerade för ditt konto:",
    methodAuthenticator: "Microsoft Authenticator-app",
    methodPhone: "Telefonsamtal / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Annan Authenticator (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Lösenord",
    methodOther: "Annan metod",
    badgeRecommended: "Rekommenderad",
    badgeActive: "Aktiv",
    badgeLegacy: "Äldre (SMS)",
    badgePrimary: "1:a faktorn",
    noMethodsFound: "Inga metoder hittades.",

    supportTitle: "Behöver du hjälp?",
    supportDesc: "Skapa ett ärende i IT Self-Service Portalen (SSP) om du behöver hjälp.",
    supportButton: "Skapa ärende i IT Self-Service Portal",
    demoModeNotice: "Demoläge aktivt"
  },

  lt: {
    languageName: "Lietuvių",
    flag: "🇱🇹",
    appTitle: "MFA Status Check",
    appSubtitle: "Dviejų veiksnių autentifikavimas",
    loginPrompt: "Prisijunkite su „Microsoft“ paskyra, kad patikrintumėte savo MFA būseną.",
    signInButton: "Prisijungti su „Microsoft“",
    signOutButton: "Atsijungti",
    accountDetails: "Paskyra",
    detectedLocation: "Vieta",
    refreshStatus: "Tikrinti dar kartą",
    checkingStatus: "Tikrinama būsena...",
    helloUser: "Sveiki",

    statusOptimalBadge: "Viskas gerai",
    statusOptimalTitle: "Esate optimaliai apsaugoti!",
    statusOptimalSubtitle: "Jokių veiksmų atlikti nereikia.",
    statusOptimalDesc: "Jūsų paskyrai nustatyta „Microsoft Authenticator“ programėlė. Papildomų veiksmų nereikia – ačiū!",
    statusOptimalFidoDesc: "Jūsų paskyrai nustatytas saugus „Passkey“ (saugumo raktas). Papildomų veiksmų nereikia – ačiū!",
    statusOptimalAction: "Viskas paruošta",

    statusNeutralBadge: "Rekomenduojamas veiksmas",
    statusNeutralTitle: "Vis dar naudojate SMS ar skambutį",
    statusNeutralSubtitle: "Prašome pereiti prie „Microsoft Authenticator“ programėlės.",
    statusNeutralDesc: "SMS ir skambučiai yra pasenę ir mažiau patikimi metodai. Pereikite prie „Microsoft Authenticator“ didesniam saugumui ir patogumui.",
    statusNeutralAction: "Nustatyti „Authenticator“ dabar",

    statusWarningBadge: "Reikalingas veiksmas",
    statusWarningTitle: "Dar nesukonfigūravote MFA!",
    statusWarningSubtitle: "Prašome nustatyti antrąjį saugumo veiksnį dabar.",
    statusWarningDesc: "Jūsų paskyra dar nėra apsaugota. Nustatykite „Microsoft Authenticator“ programėlę dabar saugiai prieigai užtikrinti.",
    statusWarningAction: "Nustatyti „Authenticator“ dabar",

    appPreinstalledNotice: "Pastaba: „Microsoft Authenticator“ programėlė jau iš anksto įdiegta jūsų darbo įrenginyje.",

    pdfGuideTitle: "Nuoseklus vadovas (PDF)",
    pdfGuideDesc: "Iliustruotas PDF vadovas „Microsoft Authenticator“ nustatymui.",
    pdfGuideButton: "Atidaryti PDF vadovą",

    toggleDetailsShow: "Rodyti registruotų metodų detales",
    toggleDetailsHide: "Slėpti detales",

    methodsHeader: "Registruoti autentifikavimo metodai",
    methodsDescription: "Šie faktoriai šiuo metu registruoti jūsų paskyrai:",
    methodAuthenticator: "„Microsoft Authenticator“ programėlė",
    methodPhone: "Telefono skambutis / SMS",
    methodFido: "FIDO2 / „Passkey“",
    methodSoftwareOath: "Kitas autentifikatorius (TOTP)",
    methodWindowsHello: "„Windows Hello“ (Passkey)",
    methodPassword: "Slaptažodis",
    methodOther: "Kitas metodas",
    badgeRecommended: "Rekomenduojama",
    badgeActive: "Aktyvus",
    badgeLegacy: "Senesnis (SMS)",
    badgePrimary: "1-asis veiksnys",
    noMethodsFound: "Metodų nerasta.",

    supportTitle: "Reikia pagalbos?",
    supportDesc: "Užregistruokite užklausą IT savitarnos portale (SSP), jei reikia pagalbos.",
    supportButton: "Registruoti užklausą IT savitarnos portale",
    demoModeNotice: "Demo peržiūra aktyvi"
  },

  es: {
    languageName: "Español",
    flag: "🇪🇸",
    appTitle: "MFA Status Check",
    appSubtitle: "Autenticación multifactor",
    loginPrompt: "Inicie sesión con su cuenta Microsoft para comprobar su estado de MFA.",
    signInButton: "Iniciar sesión con Microsoft",
    signOutButton: "Cerrar sesión",
    accountDetails: "Cuenta",
    detectedLocation: "Ubicación",
    refreshStatus: "Comprobar de nuevo",
    checkingStatus: "Comprobando estado...",
    helloUser: "Hola",

    statusOptimalBadge: "Todo listo",
    statusOptimalTitle: "¡Su cuenta está totalmente protegida!",
    statusOptimalSubtitle: "No se requiere ninguna acción.",
    statusOptimalDesc: "La aplicación Microsoft Authenticator está activa en su cuenta. No necesita hacer nada más. ¡Muchas gracias!",
    statusOptimalFidoDesc: "Tiene una clave de acceso segura (Passkey) activa en su cuenta. No necesita hacer nada más. ¡Muchas gracias!",
    statusOptimalAction: "Todo listo",

    statusNeutralBadge: "Acción recomendada",
    statusNeutralTitle: "Todavía utiliza SMS o llamada",
    statusNeutralSubtitle: "Le recomendamos cambiar a Microsoft Authenticator.",
    statusNeutralDesc: "Los SMS y las llamadas son métodos heredados y menos seguros. Cambie a la app Microsoft Authenticator para mayor seguridad y comodidad.",
    statusNeutralAction: "Configurar Authenticator ahora",

    statusWarningBadge: "Acción requerida",
    statusWarningTitle: "¡Aún no ha configurado MFA!",
    statusWarningSubtitle: "Configure su segundo factor de autenticación ahora.",
    statusWarningDesc: "Su cuenta no está protegida con verificación en dos pasos. Configure ahora la aplicación Microsoft Authenticator para mantener su acceso.",
    statusWarningAction: "Configurar Authenticator ahora",

    appPreinstalledNotice: "Nota: La aplicación Microsoft Authenticator ya está preinstalada en su dispositivo de empresa.",

    pdfGuideTitle: "Guía paso a paso (PDF)",
    pdfGuideDesc: "Guía ilustrada en PDF para configurar la aplicación Microsoft Authenticator.",
    pdfGuideButton: "Abrir guía en PDF",

    toggleDetailsShow: "Mostrar métodos registrados",
    toggleDetailsHide: "Ocultar detalles",

    methodsHeader: "Métodos registrados",
    methodsDescription: "Los siguientes factores están registrados en su cuenta:",
    methodAuthenticator: "Microsoft Authenticator",
    methodPhone: "Llamada / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Otra app autenticadora (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Contraseña",
    methodOther: "Otro método",
    badgeRecommended: "Recomendado",
    badgeActive: "Activo",
    badgeLegacy: "Heredado (SMS)",
    badgePrimary: "1er factor",
    noMethodsFound: "No se encontraron métodos.",

    supportTitle: "¿Necesita ayuda?",
    supportDesc: "Cree un ticket en el Portal de Autoservicio de TI (SSP) si necesita asistencia.",
    supportButton: "Crear ticket en el Portal de Autoservicio de TI",
    demoModeNotice: "Vista previa demo activa"
  },

  fr: {
    languageName: "Français",
    flag: "🇫🇷",
    appTitle: "MFA Status Check",
    appSubtitle: "Authentification multifacteur",
    loginPrompt: "Connectez-vous avec votre compte Microsoft pour vérifier votre statut MFA.",
    signInButton: "Se connecter avec Microsoft",
    signOutButton: "Se déconnecter",
    accountDetails: "Compte",
    detectedLocation: "Emplacement",
    refreshStatus: "Vérifier à nouveau",
    checkingStatus: "Vérification en cours...",
    helloUser: "Bonjour",

    statusOptimalBadge: "Tout est prêt",
    statusOptimalTitle: "Vous êtes parfaitement protégé !",
    statusOptimalSubtitle: "Aucune action requise.",
    statusOptimalDesc: "L'application Microsoft Authenticator est active sur votre compte. Vous n'avez rien d'autre à faire – merci !",
    statusOptimalFidoDesc: "Une clé d'accès sécurisée (Passkey) est active sur votre compte. Vous n'avez rien d'autre à faire – merci !",
    statusOptimalAction: "Tout est prêt",

    statusNeutralBadge: "Action recommandée",
    statusNeutralTitle: "Vous utilisez encore les SMS ou les appels",
    statusNeutralSubtitle: "Passez à l'application Microsoft Authenticator.",
    statusNeutralDesc: "Les SMS et les appels téléphoniques sont obsolètes et moins fiables. Passez à l'application Microsoft Authenticator pour plus de sécurité et de simplicité.",
    statusNeutralAction: "Configurer Authenticator maintenant",

    statusWarningBadge: "Action requise",
    statusWarningTitle: "Vous n'avez pas encore configuré le MFA !",
    statusWarningSubtitle: "Veuillez configurer votre 2e facteur dès maintenant.",
    statusWarningDesc: "Votre compte n'est pas encore sécurisé par un deuxième facteur. Configurez Microsoft Authenticator maintenant pour garantir vos accès.",
    statusWarningAction: "Configurer Authenticator maintenant",

    appPreinstalledNotice: "Remarque : L'application Microsoft Authenticator est déjà préinstallée sur votre appareil professionnel.",

    pdfGuideTitle: "Guide étape par étape (PDF)",
    pdfGuideDesc: "Guide PDF illustré pour configurer l'application Microsoft Authenticator.",
    pdfGuideButton: "Ouvrir le guide PDF",

    toggleDetailsShow: "Afficher les méthodes enregistrées",
    toggleDetailsHide: "Masquer les détails",

    methodsHeader: "Méthodes d'authentification enregistrées",
    methodsDescription: "Ces facteurs sont actuellement enregistrés pour votre compte :",
    methodAuthenticator: "Application Microsoft Authenticator",
    methodPhone: "Appel / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Autre application (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Mot de passe",
    methodOther: "Autre méthode",
    badgeRecommended: "Recommandé",
    badgeActive: "Actif",
    badgeLegacy: "Obsolète (SMS)",
    badgePrimary: "1er facteur",
    noMethodsFound: "Aucune méthode trouvée.",

    supportTitle: "Besoin d'aide ?",
    supportDesc: "Créez un ticket sur le portail IT Self-Service (SSP) si vous avez besoin d'aide.",
    supportButton: "Créer un ticket sur le portail IT Self-Service",
    demoModeNotice: "Aperçu démo actif"
  },

  fi: {
    languageName: "Suomi",
    flag: "🇫🇮",
    appTitle: "MFA Status Check",
    appSubtitle: "Monivaiheinen tunnistautuminen",
    loginPrompt: "Kirjaudu sisään Microsoft-tililläsi tarkistaaksesi MFA-tilasi.",
    signInButton: "Kirjaudu sisään Microsoftilla",
    signOutButton: "Kirjaudu ulos",
    accountDetails: "Tili",
    detectedLocation: "Sijainti",
    refreshStatus: "Tarkista uudelleen",
    checkingStatus: "Tarkistetaan tilaa...",
    helloUser: "Hei",

    statusOptimalBadge: "Kaikki kunnossa",
    statusOptimalTitle: "Tilisi on täysin suojattu!",
    statusOptimalSubtitle: "Toimenpiteitä ei tarvita.",
    statusOptimalDesc: "Microsoft Authenticator -sovellus on aktiivisena tililläsi. Sinun ei tarvitse tehdä mitään – kiitos!",
    statusOptimalFidoDesc: "Tililläsi on aktiivisena turvallinen passkey-tunniste (suojausavain). Sinun ei tarvitse tehdä mitään – kiitos!",
    statusOptimalAction: "Kaikki valmiina",

    statusNeutralBadge: "Toimenpidettä suositellaan",
    statusNeutralTitle: "Käytät vielä tekstiviestiä tai puhelua",
    statusNeutralSubtitle: "Vaihda Microsoft Authenticator -sovellukseen.",
    statusNeutralDesc: "Tekstiviestit ja puhelut ovat vanhentuneita ja vähemmän luotettavia menetelmiä. Siirry Microsoft Authenticatoriin paremman tietoturvan ja helppouden vuoksi.",
    statusNeutralAction: "Ota Authenticator käyttöön nyt",

    statusWarningBadge: "Toimenpide vaaditaan",
    statusWarningTitle: "Et ole vielä ottanut MFA:ta käyttöön!",
    statusWarningSubtitle: "Määritä toinen tunnistautumistekijä nyt.",
    statusWarningDesc: "Tiliäsi ei ole vielä suojattu toisella vaiheella. Ota Microsoft Authenticator käyttöön nyt varmistaaksesi pääsyn yrityksen palveluihin.",
    statusWarningAction: "Ota Authenticator käyttöön nyt",

    appPreinstalledNotice: "Huomautus: Microsoft Authenticator -sovellus on jo valmiiksi asennettuna yrityslaitteeseesi.",

    pdfGuideTitle: "Yksityiskohtainen opas (PDF)",
    pdfGuideDesc: "Kuvallinen PDF-opas Microsoft Authenticator -sovelluksen käyttöönottoon.",
    pdfGuideButton: "Avaa PDF-opas",

    toggleDetailsShow: "Näytä tallennettujen menetelmien tiedot",
    toggleDetailsHide: "Piilota tiedot",

    methodsHeader: "Tallennetut tunnistustavat",
    methodsDescription: "Seuraavat menetelmät on tällä hetkellä tallennettu tilillesi:",
    methodAuthenticator: "Microsoft Authenticator",
    methodPhone: "Puhelu / SMS",
    methodFido: "FIDO2 / Passkey",
    methodSoftwareOath: "Muu Authenticator (TOTP)",
    methodWindowsHello: "Windows Hello (Passkey)",
    methodPassword: "Salasana",
    methodOther: "Muu menetelmä",
    badgeRecommended: "Suositeltu",
    badgeActive: "Aktiivinen",
    badgeLegacy: "Vanhentunut (SMS)",
    badgePrimary: "1. tekijä",
    noMethodsFound: "Ei menetelmiä.",

    supportTitle: "Tarvitsetko apua?",
    supportDesc: "Luo tukipyyntö IT-itsepalveluportaalissa (SSP), jos tarvitset apua.",
    supportButton: "Luo tukipyyntö IT-itsepalveluportaalissa",
    demoModeNotice: "Demo-esikatselu aktiivinen"
  }
};

export const supportedLanguages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪', locations: ['DE', 'AT', 'CH'] },
  { code: 'en', name: 'English', flag: '🇬🇧', locations: ['US', 'GB', 'IE', 'CA', 'AU', 'NZ'] },
  { code: 'da', name: 'Dansk', flag: '🇩🇰', locations: ['DK'] },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺', locations: ['HU'] },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪', locations: ['SE'] },
  { code: 'lt', name: 'Lietuvių', flag: '🇱🇹', locations: ['LT'] },
  { code: 'es', name: 'Español', flag: '🇪🇸', locations: ['ES', 'MX', 'AR', 'CO', 'CL', 'PE'] },
  { code: 'fr', name: 'Français', flag: '🇫🇷', locations: ['FR', 'BE', 'LU', 'CH'] },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮', locations: ['FI'] }
];
